import { render } from "./projectReport.vue?vue&type=template&id=2937b69a&scoped=true"
import script from "./projectReport.vue?vue&type=script&lang=js"
export * from "./projectReport.vue?vue&type=script&lang=js"

import "./projectReport.vue?vue&type=style&index=0&id=2937b69a&scoped=true&lang=scss"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2937b69a"]])

export default __exports__